import tw from 'twin.macro';

export type Theme = 'dark' | 'light';

export const themes = {
  dark: {
    background: tw`bg-neutral-intense`,
    button: tw`bg-reverse-quiet hover:bg-reverse-moderate`,
    navLink: tw`text-reverse-moderate focus:border-reverse-moderate hover:bg-reverse-quiet`,
    activeNavLink: tw`text-white font-semibold bg-reverse-moderate hover:bg-reverse-moderate`,
    navLinkTreeChevron: tw`text-reverse-moderate group-hover:text-white`,
    toggleChevron: tw`bg-reverse-quiet hover:bg-reverse-moderate focus:bg-reverse-moderate focus:border-reverse-moderate`,
    toggleChevronIcon: tw`text-white!`,
  },
  light: {
    background: tw`bg-neutral-quiet`,
    button: tw`bg-neutral-moderate hover:bg-reverse-moderate`,
    navLink: tw`text-neutral-moderate hover:bg-neutral-moderate/40 focus:border-neutral-moderate`,
    activeNavLink: tw`text-neutral-intense font-semibold bg-neutral-moderate hover:bg-neutral-moderate`,
    navLinkTreeChevron: tw`text-neutral-moderate group-hover:text-neutral-intense`,
    toggleChevron: tw`bg-neutral-moderate/40 text-neutral-intense hover:bg-neutral-moderate focus:bg-neutral-moderate focus:border-neutral-moderate`,
    toggleChevronIcon: tw`text-neutral-intense!`,
  },
};
